import { Checkbox } from "@/components/checkbox";

import { validatePassword } from "./validatePassword";

export function PasswordRequirements({
  confirmPassword,
  password,
}: {
  confirmPassword: string;
  password: string;
}) {
  const rules = validatePassword(password, confirmPassword);

  const items = [
    { key: "length", label: "Must be minimum of 8 characters" },
    { key: "uppercase", label: "Must include an uppercase letter" },
    { key: "lowercase", label: "Must include an lowercase letter" },
    { key: "number", label: "Must include a number" },
    { key: "symbol", label: "Must include a symbol" },
    { key: "match", label: "Passwords must match" },
  ];

  return (
    <ul className="space-y-2">
      {items.map((item) => {
        const valid = rules[item.key as keyof typeof rules];

        return (
          <li className="flex items-center gap-2 text-sm" key={item.key}>
            {valid ? (
              <Checkbox className="w-4 h-4" isSelected={true} />
            ) : (
              <Checkbox className="w-4 h-4" isSelected={false} />
            )}
            <span className="text-text-secondary font-medium">
              {item.label}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
